<template>
    <div class="tiandimap">
        <div class="head-btn">
            <div class="head-btn-close" id="cancel" @click="onCancel">
                <i id="back" class="el-icon-arrow-left"></i>
            </div>
            <div class="head-btn-confirm" id="confirm" @click="onConfirm">确定</div>
        </div>
        <i id="local" class="el-icon-aim" @click="toLocal"></i>
        <div class="map" id="mapDiv"></div>
        <div class="search-body">
            <div class="btn-groups">
                <div class="input-wrap">
                    <el-input ref="input" id="input" class="input" v-model="keyWords" maxlength="100" placeholder="搜索地点" />
                    <i id="clear" class="el-icon-error" @click="keyWords = ''"></i>
                </div>
                <div class="btn" id="search_button" @click="onSearch">搜索</div>
            </div>
            <div class="result">
                <div class="item" v-for="item in dataSource" :key="item.hotPointID || item.id" @click="handleAddress(item)">
                    <div>
                        <div class="name">{{item.name}}</div>
                        <div class="addr">{{item.address}}</div>
                    </div>
                    <i v-if="item.lonlat == currentInfo.lonlat && item.name == currentInfo.name" id="icon-check" class="el-icon-check" @click="toLocal"></i>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import gcoord from "gcoord";
import { getPlace, getPlaceByTianditu, getIpLocation } from "./config";

  export default {
    name: 'TiandiMap',
    data() {
        return {
            mapType: 'gaode',
            centerMarker: null,
            keyWords: '',
            map: null,
            dataSource: [],
            currentInfo: ''
        };
    },
    computed: {},
    mounted() {
        const _this = this;
        document.addEventListener('UniAppJSBridgeReady', function() {
            document.getElementById('confirm').addEventListener('click', function(e) {
                console.log("🚀 ~ document.getElementById ~ e: - confirm - 0", e)
                console.log("🚀 ~ document.getElementById ~ _this.currentInfo:", _this.currentInfo)
                uni.postMessage({
                    data: {
                        title: '天地图-选择地址-确定',
                        event: 'confirm',
                        info: _this.currentInfo
                    }
                });
            });
            document.getElementById('cancel').addEventListener('click', function(e) {
                console.log("🚀 ~ document.getElementById ~ e: - cancel - 0", e)
                uni.postMessage({
                    data: {
                        title: '天地图-选择地址-取消',
                        event: 'cancel'
                    }
                });
            });
        })
        console.log('this.$route.query', localStorage.getItem('Ip'), this.$route.query);
        const { lng, lat, address } = this.$route.query;
        this.initMap(lng, lat, address);
    },
    methods: {
        initMap(lng, lat, address) {
            this.map = new T.Map('mapDiv');
            if(lng && lat){
                const result = gcoord.transform(
                    [lng, lat],    // 经纬度坐标
                    gcoord.GCJ02,             // 当前坐标系
                    gcoord.WGS84              // 目标坐标系
                );
                const lnglat = new T.LngLat(result[0], result[1]);
                this.map.centerAndZoom(lnglat, 12);
                this.centerMarker = new T.Marker(lnglat);
                this.map.addOverLay(this.centerMarker);
                this.centerMarker.enableDragging();
                this.centerMarker.addEventListener("dragend", this.dragEnd);
                this.keyWords = address;
                this.getGeocoderFun(lnglat);
            }else{
                const lnglat = new T.LngLat(116.40969,39.89945);
                this.map.centerAndZoom(lnglat, 12);
                this.getGeoLocation();
            }
        },
        getGeoLocation() {
            const lo = new T.Geolocation();
            const _this = this;
            const fn = function (e) {
                if (this.getStatus() == 0){
                    _this.map.centerAndZoom(e.lnglat, e.level)
                    _this.centerMarker = new T.Marker(e.lnglat);
                    _this.map.addOverLay(_this.centerMarker);
                    _this.getGeocoderFun(e.lnglat);
                    _this.centerMarker.enableDragging();
                    // _this.centerMarker.addEventListener("dragstart", _this.dragStart);
                    _this.centerMarker.addEventListener("dragend", _this.dragEnd);

                }
                if(this.getStatus() == 1){
                    _this.map.centerAndZoom(e.lnglat, e.level)
                    _this.centerMarker = new T.Marker(e.lnglat);
                    _this.map.addOverLay(_this.centerMarker);
                    _this.getGeocoderFun(e.lnglat);
                    _this.centerMarker.enableDragging();
                    // _this.centerMarker.addEventListener("dragstart", _this.dragStart);
                    _this.centerMarker.addEventListener("dragend", _this.dragEnd);
                }
            }
            lo.getCurrentPosition(fn);
        },
        getGeocoderFun(lnglat) {
            let geocoder = new T.Geocoder();
            geocoder.getLocation(lnglat, (result) => {
                console.log("🚀 ~ geocoder.getLocation ~ result:", result, result.getAddress())
                this.city = result.addressComponent.city;
                this.keyWords = result.getAddress();
                this.onSearch()
            });
        },
        localSearchResult(e) {
            this.dataSource = e.pois;
        },
        async onSearch() {
            if(this.mapType == 'tianditu'){
                const params = {
                        "keyWord": this.keyWords,
                        "level":12,
                        "mapBound":"-180,-90,180,90",
                        "queryType":7,
                        "start":0,
                        "count":100
                    }
                getPlaceByTianditu(params).then(res => {
                    console.log("🚀 ~ getPlaceByTianditu ~ res:", res)
                    if(res.status == 200){
                        this.dataSource = res.data.pois;
                    }
                }).catch(err => {
                    console.log("🚀 ~ getPlaceByTianditu ~ err:", err)
                    
                })
            }else{
                getPlace({
                    keywords: this.keyWords,
                    types: '010000|020000|030000|040000|050000|060000|070000|080000|090000|100000|110000|120000|130000|140000|150000|160000|170000|180000|190000|200000',
                    // offset: 20,
                    city: this.city || '厦门',
                }).then((res) => {
                    const { status, data } = res;
                    if (status == 200) {
                        if (data.pois) {
                            this.dataSource = data.pois.map(e => {
                                const lnglat = e.location.split(',');
                                const result = gcoord.transform(
                                    [lnglat[0], lnglat[1]],    // 经纬度坐标
                                    gcoord.GCJ02,             // 当前坐标系
                                    gcoord.WGS84              // 目标坐标系
                                );
                                return {
                                    ...e,
                                    lonlat: `${result[0]},${result[1]}`
                                }
                            });
                        }
                    }
                }).catch((err) => {
                    console.log("🚀 ~ err:", err)
                });
            }
        },
        onSearchByClass () {
            const localSearchResult = (result) => {
                this.dataSource = result.pois;
            }
            const config = {
                pageCapacity: 100, //每页显示的数量，最大100条
                onSearchComplete: localSearchResult	//接收数据的回调函数
            };
            //创建搜索对象
            const localsearch = new T.LocalSearch(this.map, config);
            localsearch.search(this.$refs.input.value);
        },
        dragStart(e) {
            console.log("🚀 ~ dragStart ~ e:", e)
        },
        dragEnd(e) {
            console.log("🚀 ~ dragEnd ~ e:", e)
            this.getGeocoderFun(e.lnglat);
        },
        toLocal(e) {
            this.map.clearOverLays();
            this.getGeoLocation();
        },
        getAddressZh(lng, lat) {
            const _this = this;
            const geocoder = new T.Geocoder();
            geocoder.getLocation(new T.LngLat(lng, lat), (result) => {
                console.log("🚀 ~ geocoder.getLocation ~ result.getAddress():", result.getAddress())
                _this.currentInfo.address = result.getAddress();
            });
        },
        handleAddress(item) {
            const longitude = item.lonlat.split(',')[0];
            const latitude = item.lonlat.split(',')[1];
            const lnglat = new T.LngLat(Number(longitude), Number(latitude));
            this.map.clearOverLays();
            const marker = new T.Marker(lnglat);
            this.map.addOverLay(marker);
            this.map.panTo(lnglat);
            this.getAddressZh(longitude, latitude);
            marker.enableDragging();
            marker.addEventListener("dragend", this.dragEnd);
            this.currentInfo = {
                ...item,
                longitude: Number(Number(longitude).toFixed(6)),
                latitude: Number(Number(latitude).toFixed(6)),
            };
        },
        onConfirm() {
            // console.log("🚀 ~ //document.getElementById ~ this.currentInfo:", this.currentInfo)
            // const _this = this;
            // document.getElementById('confirm').addEventListener('click', function(e) {
            //     console.log("🚀 ~ document.getElementById ~ e: - confirm - 1", e)
            //     console.log("🚀 ~ document.getElementById ~ _this.currentInfo:", _this.currentInfo)
            //     uni.postMessage({
            //         data: {
            //             title: '天地图-选择地址-确定',
            //             info: _this.currentInfo
            //         }
            //     });
            // });
        },
        onCancel() {
            // document.getElementById('cancel').addEventListener('click', function(e) {
            //     console.log("🚀 ~ document.getElementById ~ e: - cancel - 1", e)
            //     uni.postMessage({
            //         data: {
            //             title: '天地图-选择地址-取消',
            //         }
            //     });
            // });
        }
    }
  }
</script>
<style lang="scss" scoped>
.tiandimap {
    /* position: relative; */
}
#local {
    position: absolute;
    top: 36vh;
    right: 16px;
    z-index: 2;
    font-size: 24px;
    color: #1890FF;
}
.head-btn{
    position: absolute;
    top: 50px;
    width: 100%;
    z-index: 2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .head-btn-close {
        // color: #fff;
        font-size: 24px;
        margin-left: 12px;
        #back{
            font-weight: bold;
            font-size: 26px;
        }
    }
    .head-btn-confirm {
        background-color: #1890FF;
        color: #fff;
        padding: 5px 8px;
        border-radius: 2px;
        margin-right: 12px;
    }
}

.map {
    z-index: 1;
    height: 42vh;
}
.search-body {
    padding: 10px;
    .result {
        margin-top: 10px;
        height: calc(100vh - 42vh - 66px);
        overflow-y: auto;
        .item {
            border-bottom: 0.5px solid #f5f5f5;
            padding: 8px;
            text-align: left;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        #icon-check {
            color: #1890FF;
        }
    
        .name {
            font-size: 16px;
            margin-bottom: 5px;
        }
    
        .addr {
            font-size: 14px;
            color: #999;
        }
    
        .input {
            border: 1px solid #999;
            padding: 8px;
            border-radius: 4px;
            flex: 1;
        }
    }
    .btn-groups {
        display: flex;
        height: 36px;
        .input-wrap{
            position: relative;
            flex: 1;
            #clear {
                position: absolute;
                right: 5px;
                top: 12px;
                // z-index: 2;
            }
        }
    }

    .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #1890FF;
        background-color: #fff;
        /* border: 1px solid #1890FF;s */
        border-radius: 5px;
        font-size: 16px;
        text-align: center;
        margin-left: 10px;
        width: 50px;
    }
}
</style>
  